
  
<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col lg="12">
        <MemberListTable />
      </b-col>
    </b-row>
  </div>
</template>

<script>
  import MemberListTable from './MemberListTable.vue'
  export default {
    name: 'MemberList',
    components: { MemberListTable }
  }
</script>


// WEBPACK FOOTER //
// src/views/pages/MemberList/index.vue